import React, { Component } from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components';
import { DropdownOpenedIcon , DropdownClosedIcon} from '../../icons'
import styles from './defaultStyles';

class ClassificationSelector extends Component {

  handleChange = (classification) => {
    const { onChange, selectedAttributes } = this.props;
    const isChecked = this.isItemChecked(selectedAttributes, classification);
    let values = [...selectedAttributes];
    if (isChecked) {
      values.splice(values.indexOf(classification), 1);
    } else {
      values.push(classification);
    }
    onChange(values);
  };
 
  renderItems(props) {
    const { classifications, selectedAttributes, bodyTextColor } = props;
    return classifications.map((classification, index) => (
        <ItemWrapperDivStyled key={index}>
            <ItemDivStyled onClick={this.handleChange.bind(null, classification)}>
            <ItemName color={bodyTextColor} style={this.getItemStyle({classification, selectedAttributes, bodyTextColor})}>{this.getName(classification)}</ItemName>
            </ItemDivStyled>
        </ItemWrapperDivStyled>
      ))
  }

  getItemStyle = (props) => {
      const { classification, selectedAttributes, bodyTextColor } = props;
      const isChecked = this.isItemChecked(selectedAttributes, classification);
      const bgColor = this.getColor(classification);
      const txtColor = isChecked ? this.getTextColor(classification) : bodyTextColor;
      return {
        border: '1px solid #' + bgColor,
        background: isChecked ? '#' + bgColor : 'initial',
        color: txtColor
      }
  }

  getTextColor = (classification) => {
    const { bodyTextColor, brightBodyTextColor } = this.props;
    switch (classification) {
      case 'SATIVA': 
          return bodyTextColor; 
      case 'S/I': 
          return bodyTextColor; 
      case 'HYBRID': 
          return brightBodyTextColor;  
      case 'I/S': 
          return brightBodyTextColor;
      case 'INDICA': 
          return brightBodyTextColor;  
      case 'CBD': 
          return brightBodyTextColor; 
      default: 
          return bodyTextColor; 
    }
  }

  getColor = (classification) => {
    const { colors } = this.props;
    switch (classification) {
      case 'SATIVA': 
          return colors.sativaColor; 
      case 'S/I': 
          return colors.siColor; 
      case 'HYBRID': 
          return colors.hybridColor; 
      case 'I/S': 
          return colors.isColor; 
      case 'INDICA': 
          return colors.indicaColor; 
      case 'CBD': 
          return colors.cbdColor; 
      case 'KUSH': 
          return colors.kushColor; 
      default:  
          break;
    }
  }

  isItemChecked(selectedValues, classificationName) {
    return selectedValues && selectedValues.indexOf(classificationName) > -1;
  }

  headerIcon(isOpened, checkIconColor) {
    return (
      <HeaderIconWrapperDivStyled>
        {isOpened && <DropdownOpenedIcon style={styles.dropDownIcon} />}
        {!isOpened && <DropdownClosedIcon style={styles.dropDownIcon} />}
      </HeaderIconWrapperDivStyled>
    )
  }

  /* keep order */
  getClassifications(classifications) {
    let _items = [];
    const sortedItems = ['SATIVA', 'S/I', 'HYBRID', 'I/S', 'INDICA', 'CBD'];
    for (let item of sortedItems) {
      const _item = item.toUpperCase();
      if (classifications.indexOf(_item) > -1)
        _items.push(_item);
    }
    return _items;
  }

  getName(classification) {
    switch (classification) {
      case 'SATIVA': return 'SATIVA';
      case 'S/I': return 'S/I';
      case 'HYBRID': return 'HYBRID';
      case 'I/S': return 'I/S';
      case 'INDICA': return 'INDICA';
      case 'CBD': return 'CBD';
      default: return '';
    }
  }

  render() {
    const { selectedAttributes, selectedItemColor, bodyTextColor } = this.props;
    const classifications = this.getClassifications(this.props.classifications);
    return (
       <ClassificationWrapperDivStyled>
          <HeaderDivStyled color={bodyTextColor} onClick={this.props.onClick}>Classification{this.headerIcon(this.props.isOpened, selectedItemColor)}</HeaderDivStyled>
          { this.props.isOpened &&  
            <SlideDownDiv itemsLength={classifications.length}>
              { this.renderItems({ classifications, selectedAttributes, selectedItemColor, bodyTextColor }) }
            </SlideDownDiv>
          }
       </ClassificationWrapperDivStyled>
    ) 
  }
}

ClassificationSelector.propTypes = {
  colors: (props, propName) => {
    const colors = props[propName];

    if (!colors.hasOwnProperty('sativaColor')) {
      throw new Error('\'config\' must have \'sativaColor\'.')
    }

    if (!colors.hasOwnProperty('siColor')) {
      throw new Error('\'config\' must have \'siColor\'.')
    }

    if (!colors.hasOwnProperty('hybridColor')) {
      throw new Error('\'config\' must have \'hybridColor\'.')
    }
    
    if (!colors.hasOwnProperty('isColor')) {
      throw new Error('\'config\' must have \'isColor\'.')
    }
    
    if (!colors.hasOwnProperty('indicaColor')) {
      throw new Error('\'config\' must have \'indicaColor\'.')
    } 

    if (!colors.hasOwnProperty('cbdColor')) {
      throw new Error('\'config\' must have \'cbdColor\'.')
    }   
  },
  onClick: PropTypes.func,
  isOpened: PropTypes.bool,
  selectedItemColor: PropTypes.string,
  bodyTextColor: PropTypes.string,
  brightBodyTextColor: PropTypes.string,
  classifications: PropTypes.array,
  selectedAttributes: PropTypes.array,
  onChange: PropTypes.func,
}

export default ClassificationSelector;

const ClassificationWrapperDivStyled = styled.div `
  padding: 5px 0;
  width: 100%;
`;

const SlideDownDiv = styled.div `
    margin: 5px 0 0 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    height: ${props => { 
      if (props.itemsLength <= 3) {
        return '49px';
      } else if (props.itemsLength > 3) {
        return '74px';
      } 
    } }
`;

const HeaderDivStyled = styled.div `
   text-align: center;
   cursor: pointer;
   font-weight: 400;
   font-size: 16px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   color: ${ props => props.color };
`;

const HeaderIconWrapperDivStyled = styled.div `
  padding-top: 3px;
`;

const ItemWrapperDivStyled = styled.div `
  padding: 0 0 10px;
`;

const ItemName = styled.div `
  display: inline-block;
  padding: .25em 0.10em;
  border-radius: 5px;
  width: 5.714em;
  text-align: center;
  font-weight: 700;
  font-family: 'Roboto';
  font-size: 1em;
  color: ${ props => props.color };
`;

const ItemDivStyled = styled.div `
    cursor: pointer;
    display: flex;
    align-items: center;
`;




// WEBPACK FOOTER //
// ./src/components/ClassificationSelector/ClassificationSelector.jsx